import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import Floor from './Floor';
import './Plano.css';

export default function Plano({
  plano,
  prods,
  heights,
  setHeights,
  name,
  floorNumber,
  lineNumber,
  floors,
  setFloors,
  newPlano,
  setNewPlano,
  height,
  laneHeight,
}) {
  const theme = useTheme();
  const [floor, setfloor] = useState([]);

  useEffect(() => {
    let Floors = [];
    for (let i = 1; i <= floorNumber; i++) {
      Floors.push(
        <Floor
          plano={plano}
          prods={prods}
          heights={heights}
          setHeights={setHeights}
          floorNumber={floorNumber}
          setNewPlano={setNewPlano}
          newPlano={newPlano}
          floors={floors}
          setFloors={setFloors}
          height={height}
          lineNumber={lineNumber}
          floor={floorNumber - i + 1}
          key={floorNumber - i + 1}
          i={i}
        />
      );
    }
    setfloor(Floors);
  }, [heights]);

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: '32px',
        overflow: 'visible',
        // background: theme.palette.background.paper,
        minWidth: '1000px',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 2.5,
          background: `linear-gradient(135deg, ${alpha(
            theme.palette.primary.main,
            0.08
          )} 0%, ${alpha(theme.palette.secondary.main, 0.08)} 100%)`,
          borderBottom: `2px solid ${theme.palette.primary.main}`,
          display: 'flex',
          alignItems: 'center',
          borderRadius: '32px 32px 0 0',
          gap: 1.5,
        }}
      >
        <ViewModuleIcon sx={{ color: theme.palette.primary.main, fontSize: 28 }} />
        <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
          {name}
        </Typography>
      </Box>

      {/* Planogram Content */}
      <Box
        sx={{
          p: 3,
          pb: 6,
          position: 'relative',
          minHeight: `${height * 20 + 150}px`,
        }}
      >
        {floor}
      </Box>
    </Paper>
  );
}
